/* eslint-disable no-shadow */
/* eslint-disable import/no-cycle */
import ApiService from '@/services/api.service';
import { apiEndpoint, appEndpoint } from '@/shared';
import moment from 'moment';

const state = {
  countries: null,
  states: null,
  currencies: null,
  pages: null,
  types: null,
  languages: null,
  supportedCurrencies: null,
  pending: false,
};

const getters = {
  countries: (state) => (state.countries != null ? state.countries : []),
  states: (state) => (state.states != null ? state.states : []),
  types: (state) => (state.types != null ? state.types : []),
  currencies: (state) => (state.currencies != null ? state.currencies : []),
  pages: (state) => (state.pages != null ? state.pages : []),
  loadedCurrencies: (state) => state.currencies != null,
  supportedCurrencies: (state) => state.supportedCurrencies,
  pending: (state) => state.pending,
  languages: (state) => (state.languages != null ? state.languages : []),
};

const mutations = {
  clearErrors() {
    // do nothing
  },
  countries(state, countries) {
    state.countries = countries;
  },
  states(state, states) {
    state.states = states;
  },
  types(state, types) {
    state.types = types;
  },
  currencies(state, currencies) {
    state.currencies = currencies;
  },
  pages(state, pages) {
    state.pages = pages;
  },
  languages(state, languages) {
    state.languages = languages;
  },
  supportedCurrencies(state, data) {
    state.supportedCurrencies = data.map((dt) => dt.currency);
  },
  beforeLoading(state) {
    state.pending = true;
  },
  afterLoading(state) {
    state.pending = false;
  },
};

const actions = {
  async fetchCountries({ commit, getters }) {
    if (getters.countries.length) return;

    try {
      const response = await ApiService.get(`${apiEndpoint}/data/countries`);
      const data = response.data ? response.data.data : null;
      commit('countries', data);
    } catch (error) {
      // do nothing
    }
  },
  async fetchStates({ commit }, countryId) {
    try {
      commit('beforeLoading');
      const response = await ApiService.get(`${apiEndpoint}/data/countries/${countryId}/states`);
      const data = response.data ? response.data.data : null;
      commit('states', data);
      commit('afterLoading');
    } catch (error) {
      // do nothing
    }
  },
  async fetchCurrencies({ commit, getters }) {
    if (getters.currencies.length) return;

    try {
      const response = await ApiService.get(`${apiEndpoint}/data/currencies`);
      const currencies = response.data?.data?.result;
      commit('currencies', currencies);
    } catch (error) {
      // do nothing
    }
  },
  async fetchSupportedCurrencies({ commit, getters }) {
    if (getters.currencies.length) return;

    try {
      const today = moment(new Date()).format('YYYY-MM-DD');
      const response = await ApiService.get(`${apiEndpoint}/currency/supportedCurrency/${today}/${today}`);
      commit('supportedCurrencies', response.data);
    } catch (error) {
      // do nothing
    }
  },
  async fetchPropertyTypes({ commit }) {
    try {
      const response = await ApiService.get(`${apiEndpoint}/data/property-types`);
      commit('types', response.data);
    } catch (error) {
      // do nothing
    }
  },
  async fetchPages({ commit, getters }) {
    if (getters.pages.length) return;

    try {
      const response = await ApiService.get(`${apiEndpoint}/data/pages`);
      commit('pages', response.data);
    } catch (error) {
      // do nothing
    }
  },
  async fetchLanguages({ commit, getters }) {
    try {
      if (!getters.languages.length) {
        const response = await ApiService.get(`${appEndpoint}/languages`);
        commit('languages', response.data.data.result);
      }
    } catch (error) {
      // do nothing
    }
  },
  async updatePage(payload) {
    const {
      id,
      displayOrder,
    } = payload;
    try {
      return await ApiService.put(`${apiEndpoint}/pages/${id}`, { displayOrder });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
